module.exports = __webpack_public_path__ + "static/media/fullStack.778329a7.png";